import { Grid } from "@mui/material";
import { useAffiliateEarningsQuery } from "Api/Queries/Lead/useAffiliateEarningsQuery";
import { formatCurrency } from "Utils/CurrencyUtils";
import { Resources, useResource } from "Translations/Resources";
import { RegisteredUsersTile } from "Components/Affiliate/Earnings/RegisteredUsersTile";
import { PayoutTile } from "Components/Affiliate/Earnings/PayoutTile";
import { TotalEarnedTile } from "Components/Affiliate/Earnings/TotalEarnedTile";

const RESOURCES = Resources.Components.Affiliate.Earnings;

type Props = { isRegisteredUsersCountHidden?: boolean };

export const AffiliateEarningsSummary = ({
  isRegisteredUsersCountHidden,
}: Props) => {
  const { data, isLoading } = useAffiliateEarningsQuery();
  const { t } = useResource();

  if (!isLoading && !data) {
    return null;
  }

  const formatValue = (amount: number) =>
    formatCurrency({ amount, currencyCode: data?.currentPayoutCurrency });

  return (
    <Grid container spacing={2}>
      {!isRegisteredUsersCountHidden && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <RegisteredUsersTile
            isLoading={isLoading}
            value={String(data?.totalRegisteredUsers ?? 0)}
            tier1Count={data?.tier1Count ?? 0}
            tier2Count={data?.tier2Count ?? 0}
            tier3Count={data?.tier3Count ?? 0}
          />
        </Grid>
      )}
      <Grid size={{ xs: 12, sm: 6 }}>
        <PayoutTile
          isLoading={isLoading}
          value={formatValue(data?.currentPayoutAmount ?? 0)}
          hint={t(RESOURCES.PayoutHint)}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: isRegisteredUsersCountHidden ? 6 : 12 }}>
        <TotalEarnedTile
          isLoading={isLoading}
          value={formatValue(data?.totalEarned ?? 0)}
          hint={t(RESOURCES.TotalEarnedHint)}
        />
      </Grid>
    </Grid>
  );
};
